<template>
        <div  class="otp-box">
            <v-row>
                <div v-if="codeErrMessage" class="incorrect-otp"><v-icon>mdi-alert-circle</v-icon>{{otpErrMessage}} &nbsp;</div>
                <v-col cols="12" sm="12" class="pad-zero otp-cross">
                    <div class="otp-msg">Please enter the verification code sent to {{data && data.parentEmail ? data.parentEmail :'' }}</div>
                    <v-icon class="close-icon" @click="onClose">mdi-close</v-icon>
                </v-col>
                <v-col cols="12" sm="12" class="pad-zero">
                    <v-text-field  
                        v-model="verificationCode"
                        label="Verification Code"
                        outlined
                        dense
                        hide-details="auto">
                    </v-text-field>                
                </v-col>
                <div class="btn-center-align">
                    <v-btn
                        class="right-btn cust-btn resend-code-btn"
                        color="primary"
                        @click="resendCode()"
                    >Resend Code</v-btn>
                    <v-btn @click="verifyCode()" :loading="loading" class="right-btn cust-btn" color="primary">Verify and Confirm</v-btn>
                </div>
            </v-row>
        </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
    name: 'VerificationModal',
      props: ['onClose','status','data'],
        data(){
            return{
                verificationCode: null,
                codeErrMessage: null,
                loading:false
            }
        },
        computed: {
            ...mapState("userStore", ["user"])
           
        },
        methods:{
        ...mapActions({
            me: "userStore/me",
            verifyOTPWebsite: "userStore/verifyOTPWebsite",
            resendOtpWebsite: "userStore/resendOtpWebsite",
            updateUser: "userStore/updateUser"
        }),
        resendCode(){
            this.loading = true;
            if (this.validate()) {
            this.resendOtpWebsite({
                userId : this.data.parentEmail,
                parent_registration_otp: true
            })
                .then((response) => {
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                });
            } else {
                this.loading = false;
            }
        },
        verifyCode() {
            this.loading = true;
            if (this.validate()) {
            this.verifyOTPWebsite({
                userId : this.data.parentEmail,
                otp : this.verificationCode,
                external: true,
                parent_registration_otp: true
            })
                .then((response) => {
                    this.verificationCode=null;
                    this.loading = false;
                    this.onClose({ status : false});
                    this.me();
                })
                .catch((err) => {
                    this.verificationCode=null;
                    this.loading = false;
                });
            } else {
                this.loading = false;
            }
            },
            validate() {
                let isValid = true;
                return isValid;
            },
        }
}
</script>